import type { ReactNode } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { useMe } from '@/hooks/use-me';
import { NotFoundPage } from '@/pages/NotFoundPage';

/**
 * Hides Admin pages from Users entirely (they see Not found, not a disabled page).
 * The role comes from GET /api/me, never from the JWT claim in useAuth(). The API is the
 * real enforcement (R-2.1); this only shapes the UI.
 */
export function AdminRoute({ children }: { children: ReactNode }): JSX.Element {
  const { data: me, isLoading } = useMe();
  if (isLoading) {
    return (
      <div className="space-y-3 p-4 sm:p-6" data-testid="admin-route-loading">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-32 w-full" />
      </div>
    );
  }
  if (me?.role !== 'admin') return <NotFoundPage />;
  return <>{children}</>;
}
